import {
  differenceInMinutes,
  parseISO,
  setHours,
  setMinutes,
  setSeconds,
  setMilliseconds,
  subDays,
} from "date-fns";

export const shouldReFetch = (lastFetch) => {
  const diff = differenceInMinutes(new Date(), parseISO(lastFetch));
  if (diff > 20) {
    return true;
  } else return false;
};

export const shouldReFetchAgendas = (lastFetch) => {
  const diff = differenceInMinutes(new Date(), parseISO(lastFetch));
  if (diff > 9) {
    return true;
  } else return false;
};

export const toHoursAndMinutes = (totalMinutes) => {
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);

  return `${hours} Hr. ${minutes} Min.`;
};

export const calculateDuration = (array) => {
  // Calculate the total duration in minutes
  const totalMinutes = array.reduce((total, item) => total + item.duration, 0);

  // Calculate hours and minutes
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  // Create the string representation
  let durationString = "";
  if (hours > 0) {
    durationString += hours + " hr ";
  }
  if (minutes > 0) {
    durationString += minutes + " min";
  }

  return durationString.trim(); // Trim any leading/trailing whitespace
};

export function isLessThan24HoursAway(isoString) {
  // const eventTime = new Date(isoString).getTime();
  // const now = Date.now();
  // const diff = eventTime - now;

  // return diff <= 24 * 60 * 60 * 1000;
  const eventDate = new Date(isoString);

  // Get 5:00 PM of the day before the event
  const fivePMDayBefore = setMilliseconds(
    setSeconds(setMinutes(setHours(subDays(eventDate, 1), 17), 0), 0),
    0
  );

  // Compare current time to that threshold
  return Date.now() >= fivePMDayBefore.getTime();
}
